import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.emteria.background.default,
        color: theme.palette.emteria.text.primary,
    },
    box: {
        padding: theme.spacing(8),
        textAlign: "center",
        maxWidth: 600,
    },
    logo: {
        marginBottom: theme.spacing(4),
    },
    countdown: {
        marginTop: theme.spacing(3),
    },
    link: {
        marginTop: theme.spacing(3),
        display: "inline-block",
    },
    inviationTarget: {
        fontWeight: "bold",
    },
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
    },
    topSpacing: {
        marginTop: theme.spacing(1),
    },
}));
